import { getShareholderSecurityVestingData } from '@dealstack/frontend/shared/dataExchange/services/shareholder/investment.service';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { useQuery } from '@tanstack/react-query';

export const useShareholderSecurityVestingQuery = (
	investorId: string | undefined,
	securityId: string | undefined,
	enabled: boolean
) => {
	return useQuery({
		queryKey: [
			API_PATHS.SHAREHOLDER_INVESTMENT_VESTING_INVESTORID_SECURITYID_GET,
			{ investorId, securityId },
		],
		queryFn: ({ signal }) =>
			getShareholderSecurityVestingData(
				API_PATHS.SHAREHOLDER_INVESTMENT_VESTING_INVESTORID_SECURITYID_GET,
				{ investorId, securityId },
				signal
			),
		enabled: enabled && !!investorId && !!securityId,
	});
};
